import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "wrapper-filter" }
const _hoisted_3 = { class: "filter-dropdown" }
const _hoisted_4 = { class: "folders-overlay-container" }
const _hoisted_5 = { class: "folders-options-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "noResults"
}
const _hoisted_7 = {
  key: 1,
  class: "noResults"
}
const _hoisted_8 = { class: "option-folder-item" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "filter-dropdown" }
const _hoisted_11 = { class: "wrapper-palette" }
const _hoisted_12 = { class: "mask-type-wrapper" }
const _hoisted_13 = { class: "segments" }
const _hoisted_14 = { class: "filter-dropdown" }
const _hoisted_15 = { class: "mask-type-wrapper" }
const _hoisted_16 = { class: "segments" }
const _hoisted_17 = { class: "filter-dropdown" }
const _hoisted_18 = { class: "type-maks-option" }
const _hoisted_19 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_app_option = _resolveComponent("app-option")!
  const _component_app_dropdown = _resolveComponent("app-dropdown")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, {
      title: _ctx.t('filter'),
      onClose: _ctx.close
    }, null, 8, ["title", "onClose"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_app_dropdown, {
          modelValue: _ctx.folder,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.folder) = $event)),
          "is-search": true,
          "is-title": "",
          title: _ctx.t('folder'),
          label: "name",
          height: "48px",
          onSearch: _ctx.searchFolder
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.isFolderExist)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t('noResults')), 1))
                  : _createCommentVNode("", true),
                (_ctx.existFolders.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.t('noFolders')), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (item) => {
                  return (_openBlock(), _createBlock(_component_app_option, {
                    key: item.id,
                    value: item
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: require('@/assets/rainbow-folder.png'),
                          alt: "Rainbow Folder"
                        }, null, 8, _hoisted_9),
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title", "onSearch"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_app_dropdown, {
          modelValue: _ctx.paletteType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paletteType) = $event)),
          height: "48px",
          label: "name",
          "is-title": "",
          title: _ctx.t('palette')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.palettesCards, (card) => {
                return (_openBlock(), _createBlock(_component_app_option, {
                  key: card.id,
                  value: card
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.colors, (v) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: v,
                            style: _normalizeStyle({ backgroundColor: v }),
                            class: "segment"
                          }, null, 4))
                        }), 128))
                      ]),
                      _createElementVNode("span", null, _toDisplayString(card.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_app_dropdown, {
          modelValue: _ctx.maskType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maskType) = $event)),
          height: "48px",
          label: "name",
          "is-title": "",
          title: _ctx.t('mask')
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
              return (_openBlock(), _createBlock(_component_app_option, {
                key: card,
                value: card
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.segments, (v) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: v,
                          style: _normalizeStyle({ backgroundColor: v.color }),
                          class: "segment"
                        }, null, 4))
                      }), 128))
                    ]),
                    _createElementVNode("span", null, _toDisplayString(card.name), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_app_dropdown, {
          modelValue: _ctx.coloristicType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.coloristicType) = $event)),
          height: "48px",
          label: "name",
          "is-title": "",
          title: _ctx.t('typeMasks')
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coloristicTypes, (c) => {
              return (_openBlock(), _createBlock(_component_app_option, {
                key: c.id,
                value: c
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', c.icon]
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", null, _toDisplayString(c.name), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ])
    ]),
    _createElementVNode("footer", _hoisted_19, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
      }, [
        _createVNode(_component_app_button, {
          severity: "info",
          title: "clear"
        })
      ]),
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args)))
      }, [
        _createVNode(_component_app_button, {
          severity: "warning",
          title: "apply"
        })
      ])
    ])
  ], 512))
}